import './DataBlock.css';
import {deleteDeliveryAddress} from "../../../../../../CustomerHandler.js";

export default function DataBlock({ item, setEditID }) {
    const removeAddress = async () => {
        const token = sessionStorage.getItem("customerAccessToken");
        await deleteDeliveryAddress(token, item.id);
        window.location.reload();
    };

    return (
        <div className='data-block'>
            <div className='data-block-name'>{item.name}</div>
            <div className='data-block-address'>{item.street}</div>
            <div className='data-block-postal'>{`${item.city} ${item.postal}`}</div>
            <div className='data-block-phone'>{item.phone}</div>
            <div className='data-block-email'>{item.email}</div>
            <div className='data-block-managment'>
                <div className='data-block-edit-btn' onClick={() => setEditID(item.id)}>Edytuj</div>
                <div className='data-block-delete-btn' onClick={removeAddress}>Usuń</div>
            </div>
        </div>
    );
}
